import * as React from "react";
import { Link } from "react-router-dom";
import { routes } from "../../appRoutingHelpers";
import { OrganizationKeyName } from "../../model/Organization";
import { UserTermVersionListItem } from "../../service/api-response/UserTermVersionListSuccessResponse";

interface Props {
  organization: OrganizationKeyName;
  userTermId?: string;
  userTermVersion: UserTermVersionListItem;
}

const UserTermVersionListRow: React.FC<Props> = (props) => {
  const userTermVersion = props.userTermVersion;
  const userTermId = props.userTermId;
  const org = props.organization;

  return (
    <tr>
      <td>
        <Link
          to={routes.userTermVersionEdit(org, userTermId, userTermVersion.id)}
        >
          {userTermVersion.link}
        </Link>
      </td>
      <td>{userTermVersion.locale}</td>
      <td>{userTermVersion.version}</td>
      <td>
        <Link
          to={routes.userTermVersionEdit(org, userTermId, userTermVersion.id)}
          className="btn btn-sm btn-primary"
        >
          Edit
        </Link>
      </td>
    </tr>
  );
};

export default UserTermVersionListRow;
